<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="px-3 pt-3 pb-3 mr-4">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form v-show="!showSkeleton" ref="form">
      <div class="text-h4 mb-2" v-if="!edicao">Cadastro de Usuário</div>
      <v-row>
        <v-col>
          <v-text-field
            dense
            :error-messages="nameErrors"
            v-model="form.name"
            maxlength="30"
            :counter="30"
            label="Nome"
            outlined
            :disabled="id == 1 || permissaoVisualizar"
            @input="
              $v.form.name.$touch();
              form.name = $event.trim();
            "
            @blur="$v.form.name.$touch()"
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            :error-messages="emailErrors"
            v-model="form.email"
            maxlength="50"
            type="email"
            label="E-mail"
            outlined
            :disabled="permissaoVisualizar || id == 1"
            @input="$v.form.email.$touch()"
            @blur="$v.form.email.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            dense
            :error-messages="roleErrors"
            v-model="form.role"
            :items="perfis"
            outlined
            label="Perfil"
            :disabled="permissaoVisualizar || id == 1"
            @input="$v.form.role.$touch()"
            @blur="$v.form.role.$touch()"
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            :error-messages="edicao !== 'true' ? passwordErrors : passwordErrors"
            v-model="form.password"
            label="Senha"
            outlined
            maxlength="40"
            :counter="40"
            :type="showSenha ? 'text' : 'password'"
            :disabled="permissaoVisualizar"
            @click:append="showSenha = !showSenha"
            :append-icon="showSenha ? 'mdi-eye' : 'mdi-eye-off'"
            @input="edicao !== 'true' ? $v.form.password.$touch() : $v.form.password.$touch()"
            @blur="edicao !== 'true' ? $v.form.password.$touch() : null"
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            :error-messages="
              edicao !== 'true' ? password_confirmationErrors : password_confirmationErrors
            "
            v-model="form.password_confirmation"
            label="Confirmar Senha"
            outlined
            maxlength="40"
            :counter="40"
            :type="showConfirmarSenha ? 'text' : 'password'"
            :disabled="permissaoVisualizar"
            @click:append="showConfirmarSenha = !showConfirmarSenha"
            :append-icon="showConfirmarSenha ? 'mdi-eye' : 'mdi-eye-off'"
            @input="
              edicao !== 'true' ? $v.form.password_confirmation.$touch() : $v.form.password_confirmation.$touch()
            "
            @blur="
              edicao !== 'true' ? $v.form.password_confirmation.$touch() : null
            "
          />
        </v-col>
      </v-row> 
      <FixedButtons
        @salvar="salvar"
        @cancelar="cancelar"
        :pararLoader="pararLoader"
        :disableSaveButton="permissaoVisualizar"
      />
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";

import { registerVuexModule } from "@/utils/vuexUtils";
import FixedButtons from "@/componentes/FixedButtons";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";

import { validateData, validateComputed } from "../_validates/validatesForm";
import userHttpService from "../_services/userHttpService";
import usersStore from "../_store";

export default {
  props: {
    edicao: String,
    id: String,
  },
  components: { FixedButtons },
  mixins: [validationMixin],

  data: () => ({
    showSkeleton: false,
    showSenha: false,
    showConfirmarSenha: false,
    snackbar: false,
    form: {
      role: "",
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
    },
    formUpdate: {
      role: "",
      name: "",
      email: "",
      newPassword: "",
      newPassword_confirmation: "",
    },
    perfis: [],
    pararLoader: {
      parar: false,
    },
    permissaoVisualizar: false,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters("cadastroUsuarioModuleUsersStore", [
      "getSpecificUser",
      "getAllRoles",
    ]),
    ...validateComputed,
  },

  async created() {
    this.showSkeleton = true;

    registerVuexModule(
      this.$store,
      "cadastroUsuarioModuleUsersStore",
      usersStore
    );

    await this.listAllRoles();

    this.perfis = this.getAllRoles.map((role) => ({
      text: role.name,
      value: role.id,
    }));

    if (this.edicao !== 'true') {
      let senha = this.userKeyGenerate();
      this.form.password = senha;
      this.form.password_confirmation = senha;
    } else {
      this.form.name = this.getSpecificUser.name;
      this.form.email = this.getSpecificUser.email;
      this.form.role = this.getSpecificUser.roles[0].id;
    }

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (
      arrayPermissions.includes(
        process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_VISUALIZAR_CONDICIONADO
      )
    ) {
      this.permissaoVisualizar = true;
    }

    this.showSkeleton = false;
  },

  methods: {
    ...mapActions("cadastroUsuarioModuleUsersStore", ["listAllRoles"]),
    ...obtainUserPermissions,

    async salvar() {
      this.formUpdate.name = this.form.name;
      this.formUpdate.role = this.form.role;
      this.formUpdate.email = this.form.email;
      this.formUpdate.newPassword = this.form.password;
      this.formUpdate.newPassword_confirmation = this.form.password_confirmation;

      this.pararLoader.parar = false;

      try {
        this.$v.$touch();
        if (this.$v.$error) {
          if(this.edicao == 'true'){
            if(this.$v.form.role.$error == true ||
               this.$v.form.name.$error == true ||
               this.$v.form.email.$error == true){
              this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
              this.pararLoader.parar = true;
              return;
            }
            if (!(this.$v.form.password.$model.length == 0 &&
                  this.$v.form.password_confirmation.$model.length == 0 )) {
              this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
              this.pararLoader.parar = true;
              return;
            }
          }else{
              this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
              this.pararLoader.parar = true;
              return;
          }
        }
        if (this.edicao == 'true') {
          await userHttpService.putUser(this.id, this.formUpdate);
        } else {
          await userHttpService.postUser(this.form);
        }
        this.$router.push({ name: "UserHome" });
      } catch (error) {
        console.log(error);
        let key = Object.keys(error.response.data);
        this.text = error.response.data[key[0]];
        this.snackbar = true;
        this.pararLoader.parar = true;
      }
    },
    cancelar() {
      this.$router.push({ name: "UserHome" });
    },
    shuffle(string) {
      return string
        .split("")
        .sort(() => 0.5 - Math.random())
        .join("");
    },
    userKeyGenerate() {
      const upperLetter = `ABCDEFGHIJKLMNOPQRSTUVYXWZ`;
      const lowerLetter = `abcdefghijklmnopqrstuvyxwz`;
      const numbers = `0123456789`;

      const shuffleUpperLetter = this.shuffle(upperLetter).substr(0, 3);
      const shuffleLowerLetter = this.shuffle(lowerLetter).substr(0, 2);
      const shuffleNumbers = this.shuffle(numbers).substr(0, 3);

      const keyUnique = `${shuffleUpperLetter}${shuffleLowerLetter}${shuffleNumbers}`;

      return this.shuffle(keyUnique);
    },
  },
};
</script>
